<template>
  <v-container fluid>
    <v-container>
      <v-card>
        <v-card-title>Filters</v-card-title>
        <v-card-text>
          <v-select
            v-model="productVariantFilter"
            :items="productVariants"
            label="Product Variant"
            multiple
            chips
            hint="Select a product variant to filter by"
            persistent-hint
          ></v-select>
        </v-card-text>
      </v-card>
    </v-container>
    <v-container v-if="failedPaymentsReport">
      <highcharts v-if="failedPaymentsReport" :options="getChart()"/>
      <highcharts class="mt-10" v-if="failedPaymentsReport" :options="getChart('volume')"/>
      <v-row class="mt-5 mb-0 pb-0">
        <v-spacer></v-spacer>
        <v-col cols="4" class="mb-0 pb-0">
          <v-select
            v-model="percentageType"
            :items="['volume', 'amount']"
            label="Percentage Type"
          />
        </v-col>
      </v-row>
      <highcharts v-if="failedPaymentsReport" :options="getPercentageChart()"/>
      <v-btn @click="download" :disabled="loadingCSV">Download CSV</v-btn>
    </v-container>
  </v-container>
</template>

<script>
import {
  FAILED_PAYMENTS_QUERY,
  FAILED_PAYMENTS_QUERY_CSV
} from "@/graphql/queries/billing";
import FileDownloadMixin from "@/components/shared/mixins/FileDownloadMixin";

export default {
  name: "FailedPayments",
  mixins: [FileDownloadMixin],
  props: {
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
  },
  data() {
    return {
      loadingCSV: false,
      percentageType: 'volume',
      productVariantFilter: [],
      productVariants: [
        // LIFE
        {
          text: 'LIFE (Monthly)',
          value: 'standard-jeff-life'
        },
        {
          text: 'LIFE (Quarterly)',
          value: 'quarterly-jeff-life'
        },
        {
          text: 'LIFE (Bi-Annual)',
          value: 'biannual-jeff-life'
        },
        {
          text: 'LIFE (Annual)',
          value: 'annual-jeff-life'
        },
        // ONE-ON-ONE
        {
          text: '1-on-1 (Monthly)',
          value: 'standard-1-on-1'
        },
        {
          text: '1-on-1 (Quarterly)',
          value: 'quarterly-1-on-1'
        },
        {
          text: '1-on-1 (Bi-Annual)',
          value: 'biannual-1-on-1'
        },
        {
          text: '1-on-1 (Annual)',
          value: 'annual-1-on-1'
        },
        // GRAD
        {
          text: 'GRAD (Monthly)',
          value: 'standard-grad-1-on-1'
        },
        {
          text: 'GRAD (Quarterly)',
          value: 'quarterly-grad-1-on-1'
        },
        {
          text: 'GRAD (Bi-Annual)',
          value: 'biannual-grad-1-on-1'
        },
        {
          text: 'GRAD (Annual)',
          value: 'annual-grad-1-on-1'
        },
        // CLUB
        {
          text: 'CLUB (Monthly)',
          value: 'standard-jeff-club'
        },
        {
          text: 'CLUB (Quarterly)',
          value: 'quarterly-jeff-club'
        },
        {
          text: 'CLUB (Bi-Annual)',
          value: 'biannual-jeff-club'
        },
        {
          text: 'CLUB (Annual)',
          value: 'annual-jeff-club'
        }
      ]
    }
  },
  methods: {
    getPercentageChart() {
      let totalDue = Object.values(this.failedPaymentsReport.series['total_due'].data).map(e => e[this.percentageType]);
      let notResolved = Object.values(this.failedPaymentsReport.series['not_resolved'].data).map(e => e[this.percentageType])
      let resolvedOnDay = Object.values(this.failedPaymentsReport.series['resolved_on_day'].data).map(e => e[this.percentageType])
      let resolvedWithin7Days = Object.values(this.failedPaymentsReport.series['resolved_within_7_days'].data).map(e => e[this.percentageType]);

      let failedPercent = [];
      let resolvedOnDayPercent = [];
      let resolvedWithin7DaysPercent = [];
      for (let i=0; i < totalDue.length; i++) {
        let failedP = (notResolved[i] / totalDue[i]) * 100;
        let resolvedP = (resolvedOnDay[i] / totalDue[i]) * 100;
        let resolvedWithin7DaysP = (resolvedWithin7Days[i] / totalDue[i]) * 100;
        failedPercent.push(failedP);
        resolvedOnDayPercent.push(resolvedP);
        resolvedWithin7DaysPercent.push(resolvedWithin7DaysP);
      }
      let series = [
        {
          data: failedPercent,
          name: "Failed"
        },
        {
          data: resolvedWithin7DaysPercent,
          name: "Resolved within 7 days"
        },
      ];
      return {
        chart: {
          type: "line",
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        title: {
          text: `Failed Payment Report (percentage)`,
        },
        xAxis: this.failedPaymentsReport.xAxis,
        yAxis: {
          title: {
            text: "Percentage Failed",
          },
        },

        series: series,
      };
    },
    getChart(type='amount') {
      let totalDue = Object.values(this.failedPaymentsReport.series['total_due'].data).map(e => e[type])
      let notResolved = Object.values(this.failedPaymentsReport.series['not_resolved'].data).map(e => e[type])
      let resolvedOnDay = Object.values(this.failedPaymentsReport.series['resolved_on_day'].data).map(e => e[type])
      let resolvedWithin7Days = Object.values(this.failedPaymentsReport.series['resolved_within_7_days'].data).map(e => e[type])

      let series = [
        {
          data: totalDue,
          name: "Total Due"
        },
        {
          data: notResolved,
          name: "Failed"
        },
        {
          data: resolvedOnDay,
          name: "Success On Day"
        },
        {
          data: resolvedWithin7Days,
          name: "Success within 7 days"
        }
      ];
      let title = type === 'amount' ? "Payment Amount (R)" : "Payment Volume";
      return {
        chart: {
          type: "line",
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        title: {
          text: `Failed Payment Report (${type})`,
        },
        xAxis: this.failedPaymentsReport.xAxis,
        yAxis: {
          title: {
            text: title,
          },
        },

        series: series,
      };
    },
    download() {
      this.loadingCSV = true;
      this.$apollo
        .query({
          query: FAILED_PAYMENTS_QUERY_CSV,
          fetchPolicy: "no-cache",
          variables: {
            startDate: this.startDate,
            endDate: this.endDate,
            productVariants: this.productVariantFilter
          },
        })
        .then((data) => {
          if (data && data.loading === false) {
            this.loadingCSV = false;
            let fname = `${this.startDate}_${this.endDate}_failed_payments.csv`;
            let dataString = data.data.failedPaymentsReportCsv;
            this.downloadBase64File("application/csv", dataString, fname);
          }
        });
    }
  },
  apollo: {
    failedPaymentsReport: {
      query: FAILED_PAYMENTS_QUERY,
      fetchPolicy: "no-cache",
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          productVariants: this.productVariantFilter
        };
      },
      skip() {
        return !this.startDate || !this.endDate || this.startDate > this.endDate;
      },
    }
  }
}
</script>

<style scoped>

</style>